module.exports = __webpack_public_path__ + "img/m_Fortress.916483c6.png";